import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Display = forwardRef<SVGSVGElement | null, IconFilledProps>(function Display({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M1.5 4.875C1.5 3.83947 2.33947 3 3.375 3H20.625C21.6605 3 22.5 3.83947 22.5 4.875V16.125C22.5 17.1605 21.6605 18 20.625 18H14.25V19.5H18.45C18.6157 19.5 18.75 19.6343 18.75 19.8V20.7C18.75 20.8657 18.6157 21 18.45 21H5.55C5.38431 21 5.25 20.8657 5.25 20.7V19.8C5.25 19.6343 5.38431 19.5 5.55 19.5H9.75V18H3.375C2.33947 18 1.5 17.1605 1.5 16.125V4.875ZM20.625 16.5C20.8321 16.5 21 16.3321 21 16.125V4.875C21 4.66789 20.8321 4.5 20.625 4.5H3.375C3.16789 4.5 3 4.66789 3 4.875V16.125C3 16.3321 3.16789 16.5 3.375 16.5H20.625ZM12.75 18H11.25V19.5H12.75V18Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          d='M19.5 6.5C19.5 6.22386 19.2761 6 19 6H5C4.72386 6 4.5 6.22386 4.5 6.5V14.5C4.5 14.7761 4.72386 15 5 15H19C19.2761 15 19.5 14.7761 19.5 14.5V6.5Z'
          fill={filled ? color : 'transparent'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.375 3C2.33947 3 1.5 3.83947 1.5 4.875V16.125C1.5 17.1605 2.33947 18 3.375 18H9.75V19.5H5.75C5.47386 19.5 5.25 19.7239 5.25 20V20.5C5.25 20.7761 5.47386 21 5.75 21H18.25C18.5261 21 18.75 20.7761 18.75 20.5C18.75 20.3333 18.75 20.1667 18.75 20C18.75 19.7239 18.5261 19.5 18.25 19.5H14.25V18H20.625C21.6605 18 22.5 17.1605 22.5 16.125V4.875C22.5 3.83947 21.6605 3 20.625 3H3.375ZM3.375 16.5H20.625C20.8321 16.5 21 16.3321 21 16.125V4.875C21 4.66789 20.8321 4.5 20.625 4.5H3.375C3.16789 4.5 3 4.66789 3 4.875V16.125C3 16.3321 3.16789 16.5 3.375 16.5Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'display-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Display;
